export const EHAWK_NOT_PASSED_ERROR = 'ehawk failed';
